// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"e1879ed6","367":"aeebeae0","414":"627f5efd","438":"26f90a1a","464":"a90ed5a1","752":"25dd303d","795":"ace9353f","799":"84826d95","858":"5b00f0a0","885":"9cb6bbba","888":"d94f6caf"}[chunkId] + ".chunk.js";
};